import { tables } from "../utils/utils"
import { useSupabase } from "./context/useSupabase"

export const usePositionsByStructures = ({ customer, assetId, date }) => {
  const supabase = useSupabase()

  const getPositions = async () => {
    const { data, error } = await supabase
      .from(tables.FACT_POSITION_BY_STRUCTURE)
      .select("value_brl, value_usd, quantity, dim_customer!inner(), dim_asset!inner(), dim_bank_account(*)")
      .eq("dim_customer.name", customer)
      .eq("dim_asset_id", assetId)
      .eq("date", date)

    if (error) {
      console.error("Error fetching positions:", error)
      return []
    }

    return data
  }

  return { getPositions }
}
